export default __webpack_public_path__ + "1acc884b2eb552e8d27c23377fffdedf.jpg";